import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import withValidations from 'lib/hocs/withValidations';
import ValidationTypes from 'lib/constants/validationTypes';
import ValidationStore, { addValidation } from 'lib/stores/validationStore';
import ConfigStore from 'lib/stores/configStore';
import { formatIdFromName } from 'lib/utility';
import { handleChange } from 'lib/stores/formStore';
import Icons from 'lib/components/Icons';

import FormLabel from './FormLabel';
import FormError from './FormError';

const FormAttachment = ({ name, kind, label, id, attachmentName, value, valid, error, inputClass, required }) => {
  const attachmentExisting = typeof value.existing === 'string';
  const attachedFile = value.file;
  const [overrideExisting, setOverrideExisting] = useState(false);
  const vaccinationMandatory = ConfigStore.useState(s => s.vaccinationMandatory);
  const containerClasses = clsx([
    'attachment__container',
    'mb-3',
    overrideExisting && 'attachment__existing',
  ]);

  useEffect(() => {
    const initialData = {
      name: attachmentName,
      kind: kind || name.split('.').slice(-1)[0],
      file: null,
      existing: value.existing || null,
    };

    handleChange(initialData, name);
  }, [name]);

  useEffect(() => {
    if (!attachedFile && attachmentExisting) return;

    if (name === 'vaccination.certificate' && !vaccinationMandatory) return;

    ValidationStore.update(s => addValidation(s, name, !!attachedFile));
  }, [value, attachedFile]);

  const handleOverride = e => {
    e.preventDefault();

    setOverrideExisting(true);
  };

  return (
    <>
      <div className={containerClasses}>
        <FormLabel id={id || formatIdFromName(name)} label={label || name} required={required} />
        {attachmentExisting && (
          <small className="attachment__existing__text mb-2">
            <Icons.Checked />
            {value.existing}
            {' '}
            has already been uploaded.
            {' '}
            {!overrideExisting && (
              <>
                Please
                {' '}
                <button type="button" className="link" onClick={handleOverride}>
                  click here
                </button>
                {' '}
                to upload another file.
              </>
            )}
          </small>
        )}
        {(!attachmentExisting || (attachmentExisting && overrideExisting)) && (
          <>
            <input
              type="file"
              aria-label={`${attachmentName} file upload`}
              className={inputClass}
              name={`${name}.file`}
              id={id || formatIdFromName(name)}
              data-testid={`${formatIdFromName(name)}File`}
              onChange={e => handleChange(e.target.files[0], e.target.name)}
            />
            <FormError value={value} valid={valid} error={error} />
          </>
        )}
      </div>
    </>
  );
};

export default withValidations({
  type: ValidationTypes.CUSTOM,
  required: false,
})(FormAttachment);
